<!-- k-form is just for styling purposes. -->
<div class="k-form k-d-flex">
  {{ costRateValue() | shiveCurrency }}

  <div class="k-d-flex k-align-items-center">
    <div>&nbsp;pro Stunde</div>
  </div>

  <fa-icon
    class="edit turquoise icon-button k-display-flex k-align-items-stretch k-ml-3.5"
    role="button"
    (click)="openNewCostRateDialog()"
    size="lg"
    [icon]="faPenToSquare"
  ></fa-icon>
</div>
